"use client";

import { useState } from "react";

import { useAuth } from "@/context/AuthContext";

import NavWrapper from "./components/NavWrapper/NavWrapper";

import SectionWrapper from "../Section/SectionWrapper";
import NavbarLg from "./components/NavbarLg/NavbarLg";
import NavResponsive from "./components/NavResponsive/NavResponsive";

import "./Styles/Navbar.css";

const Navbar = () => {
  const { customer, logout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showNavDd, setShowNavDd] = useState(false);
  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const navbarToggle = () => {
    setShowNavDd(!showNavDd);
  };

  return (
    <NavWrapper sticky={sticky} setSticky={setSticky} drawerOpen={drawerOpen}>
      <SectionWrapper>
        <NavResponsive drawerOpen={drawerOpen} toggleDrawer={toggleDrawer} />
        <NavbarLg
          customer={customer}
          logout={logout}
          navbarToggle={navbarToggle}
          showNavDd={showNavDd}
          drawerOpen={drawerOpen}
          toggleDrawer={toggleDrawer}
        />
      </SectionWrapper>
    </NavWrapper>
  );
};

export default Navbar;
